import React, { useEffect, useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { ExportIcon, GreenArrowIcon, RedArrowIcon, SearchIcon } from "../../../../assets/icons/svgicons";
import { ROUTES } from "../../../../routes";
import Card from "../../../common/Card/Card";
import InputFormik from "../../../common/Formik/Input/InputFormik";
import { CSVLink } from "react-csv";
import { useDispatch } from "react-redux";
// import { getTransactionExportAction } from "../../../../features/user/userSlice";
import Button from "../../../common/Button/Button";
import { useDebounce } from "../../../customHook/useDebeunce";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useOutletContext } from "react-router-dom";
import {
  cardDetailsAction,
  cardTranstionAction,
  getDepositListAction,
  getTradingVolumeAction,
  getTransactionsAction,
  getTransactionsBalanceAction,
  getWithdrawListAction,
} from "../../../../features/user/userSlice";
import { Col, Nav, Row, Tab } from "react-bootstrap";
import stbltrackIcon from "../../../../assets/icons/stbltrackIcon.svg";
import withdrawIcon from "../../../../assets/icons/withdrawIcon.svg";
import transferIcon from "../../../../assets/icons/transferIcon.svg";
import Commonpagination from "../../../common/Pagination/Commonpagination";
import Table from "../../../common/Table/Table";
import Slider from "react-slick";
import styles from "./Transactions.module.scss";
import { STATUS_CODE } from "../../../../utils/constants";
import { formatDepositPrice, formatPrice } from "../../../../utils/utils";
import { format } from "date-fns";
import OpenedTransactions from "./OpenedTransactions/OpenedTransactions";
import Select from "../../../common/Formik/Select/Select";
import CopyBtn from "../../../common/CopyBtn/CopyBtn";
import Tooltip from "../../../common/Tooltip/Tooltip";

export const getType = (type) => {
  switch (type) {
    case "BUY":
      return "secondary";
    case "SELL":
      return "orange";
    case "MARKET":
    case "REDEEM":
    case "CONVERT":
    case "REWARD":
      return "primary";
    default:
      return undefined;
  }
};

const Transactions = () => {
  const cardType = localStorage.getItem("cardType");
  const [cardDetails, setCardDetails] = useState({});
  const cardId = cardType === "CREDIT" ? cardDetails?.credit?.rain_card_id : cardDetails?.debit?.rain_card_id;
  const [search, setSearch] = useState("");
  const [csvData, setCsvData] = useState([]);
  const dispatch = useDispatch();
  const debounced = useDebounce(search, 500);
  const storeCoinId = useSelector((state) => state.users.selectedCoinId);
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [transactions, setTransactions] = useState({});
  const [orderId, setOrderId] = useState({ orderId: "", transactionId: "" });
  const [imageURL, setImageURL] = useState("");
  const [show, setShow] = useState(false);
  const pageSize = 10;
  const [page, setPage] = useState(1);
  const [withdrawPage, setWithdrawPage] = useState(1);
  const [marketPages, setMarketPage] = useState(1);
  const [totalMarketPages, setTotalMarketPages] = useState();
  const [quantityOrder, setQuantityOrder] = useState(false);
  const [priceOrder, setPriceOrder] = useState(false);
  const [dateFilter, setDateFilter] = useState(false);
  const decimalLimit = useSelector((state) => state?.users?.coinDecimals);
  const [activeTab, setActiveTab] = useState("deposits");
  const [cardTransactions, setTransactionData] = useState([]);
  const [cardPage, setCardPage] = useState(1);
  const [cardFilter, setCardFilter] = useState(null);
  const [filter, setFilter] = useState(null);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");


  // const [activeTab, setActiveTab] = useState("all");
  // const [activeTab, setActiveTab] = useState(
  //   location.state?.activeTab || "deposits"
  // );

  const [depositData, setDepositData] = useState({
    currentPage: 1,
    totalItems: 0,
    totalPages: 0,
    depositlist: [],
  });
  const [withdrawData, setWithdrawData] = useState({
    currentPage: 1,
    totalItems: 0,
    totalPages: 0,
    withdrawlist: [],
  });
  const cardFilterOptions = [
    {
      label: "Debit Card",
      value: cardDetails?.debit?.rain_card_id,
    },
    {
      label: "Credit Card",
      value: cardDetails?.credit?.rain_card_id,
    },
  ].filter(option => option.value);


  const [transactionBalance, setTransactionBalance] = useState({
    totalDeposits: 0,
    totalWithdraws: 0,
  });
  const [tradingVolume, setTradingVolume] = useState(0);
  const [error, setError] = useState(null);
  const [coinOptions, setCoinOptions] = useState([]);
  const [coinLists, setCoinList] = useState([]);

  const formatTransactionId = (id) => {
    if (!id) return "-";
    if (id.length <= 10) return id;
    return `${id.slice(0, 5)}...${id.slice(-5)}`;
  };

  const cardTransactionHeaders = [
    { label: "Transaction Id" },
    { label: "Amount" },
    { label: "Transaction Status" },
    { label: "Type" },
    { label: "Date & Time" },
  ];

  // const getCardDetails = async () => {
  //   try {
  //     const res = await dispatch(cardDetailsAction());
  //     if (res?.status === 200) {
  //       const cards = res?.data?.data || [];
  //       const debit = cards.find((c) => c.card_type === "DEBIT");
  //       const credit = cards.find((c) => c.card_type === "CREDIT");
  //       setCardDetails({ debit: debit, credit: credit })
  //     } else {
  //       setCardDetails({});
  //     }
  //   } catch (error) {
  //     console.log(error, "error");
  //   }
  // }

  // useEffect(() => {
  //   getCardDetails()
  // }, [])



  const getTransactionsBalance = async () => {
    try {
      const response = await dispatch(getTransactionsBalanceAction());
      if (response.data.status === STATUS_CODE.successful) {
        setTransactionBalance({
          totalDeposits: response?.data?.data?.totalDeposits || 0,
          totalWithdraws: response?.data?.data?.totalWithdraws || 0,
        });
      } else {
        setTransactionBalance({
          totalDeposits: 0,
          totalWithdraws: 0,
        });
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  const getTradingVolume = async () => {
    try {
      const response = await dispatch(getTradingVolumeAction());
      if (response.data.status === STATUS_CODE.successful) {
        setTradingVolume(response?.data?.data?.total_trading_volume || 0);
      } else {
        setTradingVolume(0);
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  useEffect(() => {
    getTradingVolume();
    getTransactionsBalance();
  }, []);
  useEffect(() => {
    if (activeTab === "cardActivity" && cardFilter?.value) {
      cardTranstionData();
    }
  }, [activeTab, cardPage, debounced, cardFilter]);

  useEffect(() => {
    if (!cardFilter && cardDetails?.debit?.rain_card_id) {
      setCardFilter({
        label: "Debit Card",
        value: cardDetails.debit.rain_card_id,
      });
    }
  }, [cardDetails, cardFilter]);




  const transactioncard = [
    {
      classcard: "",
      iconcard: stbltrackIcon,
      label: "Total Deposits",
      values: `$${formatPrice(transactionBalance?.totalDeposits)}`,
    },
    {
      classcard: "light_green",
      iconcard: withdrawIcon,
      label: "Total Withdrawals",
      values: `$${formatPrice(transactionBalance?.totalWithdraws)}`,
    },
    {
      classcard: "light_blue",
      iconcard: transferIcon,
      label: "Trading Volume",
      values: `$${tradingVolume}`,
    },
  ];
  const getStatusClass = (status) => {
    switch (status) {
      case 1:
        return "processing";
      case 2:
        return "completed";
      case 3:
        return "rejected";
      default:
        return "";
    }
  };
  // DEPOSIT LIST FUNCTION
  const depositHistory = async () => {
    setLoading(true);
    try {
      const payload = {
        limit: 10,
        page: page,
      };
      const response = await dispatch(getDepositListAction(payload));
      if (response.data.status === STATUS_CODE.successful) {
        const data = response.data.data;
        setDepositData({
          currentPage: data?.currentPage,
          totalItems: data?.totalItems,
          totalPages: data?.totalPages,
          depositlist: data?.depositlist || [],
        });
      } else {
        setDepositData({
          currentPage: 1,
          totalItems: 0,
          totalPages: 0,
          depositlist: [],
        });
      }
    } catch (error) {
      setError("Error fetching deposit history.");
      console.error("Error fetching deposit history:", error);
    } finally {
      setLoading(false);
    }
  };

  // WITHDRAW LIST FUNCTION
  const withdrawHistory = async () => {
    setLoading(true);
    try {
      const payload = {
        limit: 10,
        page: withdrawPage,
      };
      const response = await dispatch(getWithdrawListAction(payload));
      if (response.data.status === STATUS_CODE.successful) {
        const data = response.data.data;
        setWithdrawData({
          currentPage: data?.currentPage,
          totalItems: data?.totalItems,
          totalPages: data?.totalPages,
          withdrawlist: data?.withdrawlist || [],
        });
      } else {
        setWithdrawData({
          currentPage: 1,
          totalItems: 0,
          totalPages: 0,
          withdrawlist: [],
        });
      }
    } catch (error) {
      setError("Error fetching Withdraw history.");
      console.log(error, "error");
    } finally {
      setLoading(false);
    }
  };

  const cardTranstionData = async () => {
    
    if (!cardFilter?.value) return;

    try {
      setLoading(true);

      const data = {
        page: cardPage,
        limit: 10,
        ...(debounced && { search: debounced }),
        ...(startDate && endDate && {
          startDate: format(new Date(startDate), "yyyy-MM-dd"),
          endDate: format(new Date(endDate), "yyyy-MM-dd"),
        }),
      };

      const res = await dispatch(
        cardTranstionAction(cardFilter.value, data)
      );

      if (res?.status === 200) {
        setTransactionData(res?.data?.data?.transactions || []);
      }
    } catch (error) {
      console.log("Card transaction error", error);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    if (activeTab === "deposits") {
      depositHistory();
    } else if (activeTab === "withdrawals") {
      withdrawHistory();
    } else if (activeTab === "marketplace") {
      getTransactions();
    } else if (activeTab === "cardActivity") {
      cardTranstionData();
    }
  }, [activeTab, page, withdrawPage, marketPages]);

  // const fetchCoinOptions = async () => {
  //     setLoading(true);
  //     try {
  //       const response = await dispatch(getUserCoinListAction());
  //       if (response.data.status === STATUS_CODE.successful) {
  //         const array = [];
  //         const newData = response.data.data.coinList;
  //         setCoinList(newData);
  //         newData?.forEach((coin) => {
  //           array.push({
  //             value: coin.id,
  //             label: coin.coin_symbol,
  //             networkdetails: coin.networkDetail,
  //             coinImage: coin.image_path,
  //           });
  //         });
  //         setCoinOptions(array);
  //         console.log("array", array);
  //         if (array.length > 0) {
  //           const defaultCoin = array[0];
  //           // setSelectedCoin(defaultCoin);
  //           // withdrawHistory();
  //           // depositHistory();
  //           const defaultNetwork = defaultCoin.networkdetails[0];
  //           // setSelectedNetwork({
  //           //   value: defaultNetwork.id,
  //           //   label: defaultNetwork.parent_coin_name,
  //           // });
  //           // setNetworkOptions(
  //           //   defaultCoin.networkdetails.map((network) => ({
  //           //     value: network.id,
  //           //     label: network.parent_coin_name,
  //           //   }))
  //           // );
  //         }
  //       }
  //     } catch (error) {
  //       setError("Error fetching coin options.");
  //       console.error("Error fetching coin options:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  const formatCoin = (id) => {
    const defaultCoin = coinOptions?.find((coin) => coin.label === "BTC");
    if (!id)
      return defaultCoin ? (
        <div className={styles.coin}>
          <img
            src={defaultCoin.coinImage}
            alt={defaultCoin.label}
            className={styles.coinImage}
          />
          {defaultCoin.label}
        </div>
      ) : (
        "BTC"
      );

    const coin = coinOptions?.find((coin) => coin.value === id);
    return coin ? (
      <div className={styles.coin}>
        <img
          src={coin.coinImage}
          alt={coin.label}
          className={styles.coinImage}
        />
        {coin.label}
      </div>
    ) : defaultCoin ? (
      <div className={styles.coin}>
        <img
          src={defaultCoin.coinImage}
          alt={defaultCoin.label}
          className={styles.coinImage}
        />
        {defaultCoin.label}
      </div>
    ) : (
      "Unknown Coin"
    );
  };

  const getTransactions = async (data) => {
    setLoading(true);
    try {
      const params = {
        page: marketPages,
        size: pageSize,
        filterByStatus: "COMPLETED",
      };
      if (debounced) {
        params.searchKeyword = debounced;
      }
      if (data === "Qty") {
        params.sortByQuantity = quantityOrder == true ? "ASC" : "DESC";
      }
      if (data === "Date") {
        params.sortByDate = dateFilter == true ? "ASC" : "DESC";
      }
      if (data === "Price") {
        params.sortByPrice = priceOrder == true ? "ASC" : "DESC";
      }

      const response = await dispatch(getTransactionsAction(params));
      if (response.status === 200) {
        setTransactions(response.data.data.data);
        setTotalMarketPages(response?.data?.data?.totalPages);
        setImageURL(response.data.data.imageUrl);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  // Common headers for all transactions
  const allHeaders = [
    { label: "Date" },
    { label: "Type" },
    { label: "Asset" },
    { label: "Quantity" },
    { label: "Amount" },
    { label: "Status" },
    { label: "Action" },
  ];

  // Headers specifically for Deposit history
  const depositHeaders = [
    { label: "Date" },
    { label: "Transaction ID" },
    { label: "Coin" },
    { label: "Amount" },
    { label: "Status" },
    // { label: "Action" },
  ];

  // Headers for Withdrawals
  const withdrawHeaders = [
    { label: "Date" },
    { label: "Transaction ID" },
    { label: "Coin" },
    { label: "Amount" },
    { label: "Fee" },
    { label: "Status" },
    // { label: "Action" },
  ];

  // Headers for Marketplace
  const marketplaceHeaders = [
    { label: "Date" },
    { label: "Type" },
    { label: "Asset" },
    { label: "Quantity" },
    { label: "Price" },
    { label: "Status" },
    // { label: "Action" },
  ];

  const userBalanceData = [
    { date: "2024-01-15", type: "Buy", asset: "Gold STBL", amount: "+2.5 GSTBL", value: "$5,250.00", status: "Completed", },
    { date: "2024-01-15", type: "Deposit", asset: "USD", amount: "+$10,000.00", value: "$5,250.00", status: "Processing", },
    { date: "2024-01-15", type: "Sell", asset: "Silver STBL", amount: "-15.0 SSTBL", value: "$5,250.00", status: "Completed", },
    { date: "2024-01-15", type: "Card Payment", asset: "Gold STBL", amount: "+2.5 GSTBL", value: "$5,250.00", status: "Processing", },
    { date: "2024-01-15", type: "Withdraw", asset: "Gold STBL", amount: "+2.5 GSTBL", value: "$5,250.00", status: "Completed", },
    { date: "2024-01-15", type: "Buy", asset: "Gold STBL", amount: "+2.5 GSTBL", value: "$5,250.00", status: "Processing", },
    { date: "2024-01-15", type: "Buy", asset: "Gold STBL", amount: "+2.5 GSTBL", value: "$5,250.00", status: "Completed", },
    { date: "2024-01-15", type: "Buy", asset: "Gold STBL", amount: "+2.5 GSTBL", value: "$5,250.00", status: "Completed", },
    { date: "2024-01-15", type: "Buy", asset: "Gold STBL", amount: "+2.5 GSTBL", value: "$5,250.00", status: "Completed", },
    { date: "2024-01-15", type: "Buy", asset: "Gold STBL", amount: "+2.5 GSTBL", value: "$5,250.00", status: "Completed", },
  ];
  const settings = {
    dots: false,
    infinite: false,
    arrow: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 767,
        arrow: true,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 679,
        arrow: true,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 355,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  // useEffect(() => {
  //   setActiveTab("deposits");
  //   depositHistory();
  // }, []);

  useEffect(() => {
    setActiveTab("deposits");
    // depositHistory() removed — let the main useEffect handle it
  }, []);

  // 1. Fix dependency
  useEffect(() => {
    if (location.state?.activeTab) {
      setActiveTab(location.state.activeTab);
    }
  }, [location.state?.activeTab]); // ← Fixed this line

  useEffect(() => {
    if (
      activeTab === "marketplace" &&
      location.state?.activeTab === "marketplace"
    ) {
      getTransactions();
      window.history.replaceState({}, document.title); // clears state after use
    }
  }, [activeTab, location.state?.activeTab]);

  const formatDepositStatus = (status) => {
    switch (status) {
      case 1:
      case 6:
        return "Completed";
      case 0:
        return "Pending";
      case 2:
        return "Completed";
      case 3:
        return "Completed";
      case 4:
        return "Completed";
      case 5:
        return "Error while Moved to Central Wallet";
      default:
        return "Unknown Status";
    }
  };

  const formatStatus = (status) => {
    switch (status) {
      case 1:
        return "Pending";
      case 2:
        return "In Progress";
      case 3:
        return "Rejected";
      case 5:
        return "Cancelled";
      case 6:
        return "Confirmed";
      default:
        return "In Progress";
    }
  };

  useEffect(() => {
    setPage(1);
    setWithdrawPage(1);
    setMarketPage(1);
  }, [activeTab]);

  return (
    <>
      {/* <Card
        title={
          <>
            <span className="d-md-inline d-none">My</span> Transactions
          </>
        }
        className={styles.transactions}
        bodyClassName={styles.body}
        headerClassName={styles.headerCard}
        headerContent={
          <>
            <InputFormik
              onChange={(e) => setSearch(e.target.value)}
              value={search}
              icon={<SearchIcon />}
              placeholder="Search by Order ID..."
              iconClassName={styles.search_icon}
              className={styles.search_input}
            />
            <div className={`${styles.tabs} ${styles.tabsNew}`}>
              <NavLink
                onClick={() => setSearch("")}
                to={ROUTES.TRANSACTIONS_OPENED}
              >
                Open
              </NavLink>
              <NavLink
                onClick={() => setSearch("")}
                to={ROUTES.TRANSACTIONS_COMPLETED}
              >
                Completed
                <span className={styles.d_text}>d</span>
              </NavLink>
            </div>

            <CSVLink
              data={csvData}
              filename={"Transactions.csv"}
              className={styles.csv_link}
            >
              <Button
                className={`${styles.tableexport_btn} ${styles.btn || ""}`}
              >
                Export
                <span>
                  <ExportIcon />
                </span>
              </Button>
            </CSVLink>
          </>
        }
      >
        <Outlet context={search} />
      </Card> */}
      <section className={styles.transactions}>
        <div className={styles.transactions_topCards}>
          <Row>
            {transactioncard.map((items, index) => (
              <Col lg={4} md={6} xs={12} key={index} className="card_col">
                <div className={`${styles.cardtransaction} ${items.classcard}`}>
                  <div className={styles.icon_track}>
                    <img src={items.iconcard} alt="icons" />
                  </div>
                  <div className={styles.text_sec}>
                    <label>{items.label}</label>
                    <h4 className="big">{items.values}</h4>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </div>
        <div className={styles.transactions_tabsSec}>
          <Tab.Container
            id="left-tabs-example"
            activeKey={activeTab}
            // onSelect={(key) => {
            //   setActiveTab(key);
            //   if (key === "marketplace") {
            //     getTransactions();
            //   } else if (key === "deposits") {
            //     depositHistory();
            //   } else if (key === "withdrawals") {
            //     withdrawHistory();
            //   }
            // }}
            onSelect={(key) => setActiveTab(key)}
            className="tabContainer"
          >
            <div className="tabHeader">
              <div className="heading">
                <h4>Transaction History</h4>
              </div>
              <div className="tabHeader_innertab">
                <Nav variant="pills" className="navTabs">
                  <Slider {...settings}>
                    {/* <Nav.Item>
                      <Nav.Link eventKey="all">All</Nav.Link>
                    </Nav.Item> */}
                    <Nav.Item>
                      <Nav.Link eventKey="deposits">Deposits</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="withdrawals">Withdrawals</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="marketplace">Marketplace</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="cardActivity">Card Transactions</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="redeem">Redeem</Nav.Link>
                    </Nav.Item>
                  </Slider>
                </Nav>
              </div>
            </div>
            <Tab.Content>
              {/* <Tab.Pane eventKey="all">
                <div className="tab_data">
                  <Table
                    noRecordContent={"No records were found."}
                    noRecordClassName={styles.no_content}
                    noContentVariant="large"
                    // loading={loading}
                    loadingClassName={"loading_table"}
                    className="table"
                    fields={allHeaders}
                  >
                    {userBalanceData?.length > 0 ? (
                      userBalanceData.map((item, index) => (
                        <tr key={index}>
                          <td>{item.date}</td>
                          <td>{item.type}</td>
                          <td>{item.asset}</td>
                          <td>{item.amount}</td>
                          <td>{item.value}</td>
                          <td>
                            <div
                              className={`status ${getStatusClass(
                                item.status
                              )}`}
                            >
                              {item.status}
                            </div>
                          </td>
                          <td>
                            <Button variant="text_blue" className="detail_btn">
                              View Details
                            </Button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan={allHeaders.length}
                          style={{ textAlign: "center" }}
                        >
                          No records found!
                        </td>
                      </tr>
                    )}
                  </Table>

                  <Commonpagination
                    pagination
                    currentPage={2}
                    className={styles.pagination}
                    pageSize={10}
                    totalPages={6}
                    // handlePageChange={(selected) => setPage(selected)}
                  />
                </div>
              </Tab.Pane> */}
              <Tab.Pane eventKey="deposits">
                <div className="tab_data">
                  <Table
                    noRecordContent={"No records were found."}
                    noRecordClassName={styles.no_content}
                    noContentVariant="large"
                    loading={loading}
                    loadingClassName={"loading_table"}
                    className="table"
                    fields={depositHeaders}
                  >
                    {depositData?.depositlist?.length > 0 ? (
                      depositData?.depositlist?.map((item, index) => (
                        <tr key={index}>
                          {/* <td>
                            {format(
                              new Date(item.created_at),
                              "dd MMM, yyyy"
                            ) || "NA"}
                          </td> */}
                          <td>
  {item?.created_at &&
    !isNaN(new Date(item.created_at).getTime())
    ? format(new Date(item.created_at), "dd MMM, yyyy hh:mm a")
    : "NA"}
</td>

                          <td>   <Tooltip
                            icon={<span>{formatTransactionId(item?.transaction_id) || "NA"}</span>}
                            content={
                              <>
                                <CopyBtn text={item?.transaction_id} /> {item?.transaction_id}
                              </>
                            }
                          /></td>
                          <td>{item?.coin_symbol || "NA"}</td>
                          <td>{formatPrice(Number(item?.amount)) || "NA"}</td>
                          <td>{formatDepositStatus(item.status) || "NA"}</td>
                          {/* <td>
                            <Button variant="text_blue" className="detail_btn">
                              View Details
                            </Button>
                          </td> */}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan={depositHeaders.length}
                          style={{ textAlign: "center" }}
                        >
                          No records found!
                        </td>
                      </tr>
                    )}
                  </Table>

                  {depositData?.totalPages > 1 && (
                    <Commonpagination
                      pagination
                      currentPage={depositData?.currentPage}
                      className={styles.pagination}
                      pageSize={10}
                      totalPages={depositData?.totalPages}
                      handlePageChange={(selected) => setPage(selected)}
                    />
                  )}
                </div>
              </Tab.Pane>
              <Tab.Pane eventKey="withdrawals">
                <div className="tab_data">
                  <Table
                    noRecordContent={"No records were found."}
                    noRecordClassName={styles.no_content}
                    noContentVariant="large"
                    loading={loading}
                    loadingClassName={"loading_table"}
                    className="table"
                    fields={withdrawHeaders}
                  >
                    {withdrawData?.withdrawlist?.length > 0 ? (
                      withdrawData?.withdrawlist?.map((item, index) => (
                        <tr key={index}>
                          {/* <td>
                            {format(
                              new Date(item.created_at),
                              "dd MMM, yyyy"
                            ) || "NA"}
                          </td> */}
                          <td>
  {item?.created_at &&
    !isNaN(new Date(item.created_at).getTime())
    ? format(new Date(item.created_at), "dd MMM, yyyy hh:mm a")
    : "NA"}
</td>
                          <td>
                            <Tooltip
                              icon={
                                <span>
                                  {formatTransactionId(item?.transaction_id) ||
                                    "NA"}
                                </span>
                              }
                              content={
                                <>
                                  <CopyBtn text={item?.transaction_id} />{" "}
                                  {item?.transaction_id}
                                </>
                              }
                            />
                          </td>
                          <td>{item?.coin_symbol || "NA"}</td>
                          <td>{formatPrice(Number(item?.amount)) || "NA"}</td>
                          <td>{formatPrice(Number(item?.fee)) || 0}</td>
                          <td> {formatStatus(item.status)}</td>
                          {/* <td>
                            <Button variant="text_blue" className="detail_btn">
                              View Details 
                            </Button>
                          </td> */}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan={withdrawHeaders.length}
                          style={{ textAlign: "center" }}
                        >
                          No records found!
                        </td>
                      </tr>
                    )}
                  </Table>

                  {withdrawData?.totalPages > 1 && (
                    <Commonpagination
                      pagination
                      currentPage={withdrawData?.currentPage}
                      className={styles.pagination}
                      pageSize={10}
                      totalPages={withdrawData?.totalPages}
                      handlePageChange={(selected) => setWithdrawPage(selected)}
                    />
                  )}
                </div>
              </Tab.Pane>
              <Tab.Pane eventKey="marketplace">
                <div className="tab_data">
                  <Table
                    noRecordContent={"No records were found."}
                    noRecordClassName={styles.no_content}
                    noContentVariant="large"
                    // loading={loading}
                    loadingClassName={"loading_table"}
                    className="table"
                    fields={marketplaceHeaders}
                  >
                    {transactions?.length > 0 ? (
                      transactions.map((item, index) => (
                        <tr key={index}>
                          {/* <td>{format(
                            new Date(item.created_at),
                            "dd MMM, yyyy"
                          ) || "NA"}</td> */}

                          <td>
  {item?.created_at &&
    !isNaN(new Date(item.created_at).getTime())
    ? format(new Date(item.created_at), "dd MMM, yyyy hh:mm a")
    : "NA"}
</td>
                          <td>{item.type}</td>
                          <td>{item.master_tokens_configuration?.name}</td>
                          <td>{formatPrice(item.quantity)}</td>
                          <td>{item?.type === "REWARD" ? "-" : `$ ${formatPrice(item.price)}`}</td>
                          <td>
                            <div
                              className={`status ${getStatusClass(
                                item.status
                              )}`}
                            >
                              {item.status}
                            </div>
                          </td>
                          {/* <td>
                            <Button variant="text_blue" className="detail_btn">
                              View Details
                            </Button>
                          </td> */}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan={marketplaceHeaders.length}
                          style={{ textAlign: "center" }}
                        >
                          No records found!
                        </td>
                      </tr>
                    )}
                  </Table>

                  {totalMarketPages > 1 && (
                    <Commonpagination
                      pagination
                      currentPage={marketPages}
                      className={styles.pagination}
                      pageSize={10}
                      totalPages={totalMarketPages}
                      handlePageChange={(selected) => setMarketPage(selected)}
                    />
                  )}
                </div>
              </Tab.Pane>
              <Tab.Pane eventKey="cardActivity">
                <div className="tab_data">

                  {/* Filter */}
                  <div className={styles.card_filter}>
                    <Select
                      options={cardFilterOptions}
                      value={cardFilter}
                      onChange={(val) => {
                        setCardFilter(val);
                        setCardPage(1);
                      }}
                    />
                  </div>

                  {/* Table */}
                  <Table
                    noRecordContent={"No records were found."}
                    noRecordClassName={styles.no_content}
                    noContentVariant="large"
                    loading={loading}
                    loadingClassName={"loading_table"}
                    className="table"
                    fields={cardTransactionHeaders}
                  >
                    {cardTransactions?.length > 0 ? (
                      cardTransactions.map((item, index) => (
                        <tr key={index}>
                          <td>
                            {item?.external_transaction_id
                              ? item.external_transaction_id
                              : item?.id}
                          </td>
                          <td>
                            {item?.amount}
                            &nbsp;
                            <span>{item?.transaction_type_api === "spend" ? <RedArrowIcon /> : <GreenArrowIcon />}</span>
                          </td>
                          <td>{item?.transaction_status}</td>
                          <td>{item?.transaction_type_api === "load" ? "Top Up" : "Spend"}</td>
                          <td>{item?.created_at &&
                            !isNaN(
                              new Date(item?.created_at).getTime()
                            )
                            ? format(
                              new Date(item?.created_at),
                              "dd MMM, yyyy hh:mm a"
                            )
                            : "Invalid date"}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={cardTransactionHeaders.length} style={{ textAlign: "center" }}>
                          No records found!
                        </td>
                      </tr>
                    )}
                  </Table>

                  {/* Pagination */}
                  {cardTransactions?.length > 0 && (
                    <Commonpagination
                      pagination
                      currentPage={cardPage}
                      className={styles.pagination}
                      pageSize={10}
                      totalPages={Math.ceil(cardTransactions.length / 10)}
                      handlePageChange={(selected) => setCardPage(selected)}
                    />
                  )}
                </div>
              </Tab.Pane>

              <Tab.Pane eventKey="redeem">
                {/* <div className="tab_data">
                </div> */}
                <OpenedTransactions status="REDEEM" />
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>
      </section>
    </>
  );
};

export default Transactions;
